<template>
  <div class="about-page">
    <div class="overlay"></div>
    <Header />
    
    <main class="main-content">
      <!-- 视频背景区域 -->
      <section class="video-section">
        <div class="video-container">
          <video autoplay muted loop playsinline id="bgVideo">
            <source src="@/assets/images/video.mp4" type="video/mp4">
          </video>
          <div class="video-overlay">
            <h1 class="glow-text">数据驱动智造，协同创造价值</h1>
            <p class="sub-text">融合高端制造业的严谨性与数字化技术的未来感</p>
          </div>
        </div>
      </section>

      <!-- 公司介绍区域 -->
      <section class="about-content">
        <div class="container">
          <h2 class="section-title" data-aos="fade-up">腾智赋能</h2>
          <div class="about-grid">
            <div class="about-text">
              <p class="company-intro">腾智是一家致力于为企业带来数字化价值应用、提供企业管理咨询服务与智慧管理软件产品为核心的创新型科技公司，为推动企业数字化、信息化管理升级，为企业实现智慧管理提供不竭的创新动力。</p>
              <p class="company-intro">腾智以智能制造为核心，集成"管理精益化、业务数字化、决策智慧化"的需求，融合精益管理思想，研究智慧管理解决方案和研发企业管理软件产品，帮助企业优化管理流程，改善供应链运营，快速提高运营效率，推动精益管理，合理利用企业资源，提升产品质量，从而助力企业实现协同高效化、生产数字化、管理智慧化，进而提升制造企业核心竞争力，最终使企业保持持续盈利能力和可持续发展动力，宝能工业4.0时代！</p>
              <p class="company-intro">腾智科技致力于为制造业企业提供智能化、一体化的ERP解决方案，助力企业数字化转型升级。我们以创新技术为驱动，以客户价值为核心，打造行业领先的智能制造生态系统。</p>     
            </div>
                  
            <div class="stats-grid">
              <div class="stat-item" v-for="(stat, index) in stats" :key="index">
                <div class="stat-number" :data-target="stat.value">0</div>
                <div class="stat-label">{{ stat.label }}</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- 荣誉资质区域 -->
      <section class="certificates-section">
        <div class="container">
          <h2 class="section-title" data-aos="fade-up">荣誉资质</h2>
          <!-- 滑动门导航 -->
          <div class="tab-nav">
            <ul>
              <li v-for="(tab, index) in tabs" 
                  :key="index" 
                  :class="{ active: activeTabIndex === index }" 
                  @click="setActiveTab(index)" 
                  :data-tab="tab.id">{{ tab.name }}</li>
            </ul>
          </div>
          
          <!-- 滑动内容区域 -->
          <div class="tab-content">
            <div v-for="(tab, index) in tabs" 
                 :key="index" 
                 class="tab-pane" 
                 :class="{ active: activeTabIndex === index }" 
                 :id="tab.id">
              <div class="certificate-slider">
                <button class="slider-nav prev" @click="prevSlide"><i class="fas fa-chevron-left"></i></button>
                <div class="slider-container">
                  <div class="slider-track" ref="sliderTrack">
                    <div v-for="(certificate, cIndex) in tab.certificates" :key="cIndex" class="slide">
                      <img :src="require(`@/assets/images/${certificate.image}`)" :alt="certificate.title">
                      <div class="slide-title">
                        <i :class="certificate.icon"></i>
                        <span>{{ certificate.title }}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <button class="slider-nav next" @click="nextSlide"><i class="fas fa-chevron-right"></i></button>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      <!-- 合作伙伴区域 -->
      <section class="partners-section">
        <div class="container">
          <h2 class="section-title" data-aos="fade-up">合作伙伴</h2>
          <div class="partners-scroll">
            <div class="scroll-row row1">
              <!-- 第一排向右滚动 -->
              <img v-for="partner in partnersRow1" :key="partner.name" :src="require(`@/assets/images/${partner.image}`)" :alt="partner.name">
              <img v-for="partner in partnersRow1" :key="partner.name + '-clone'" :src="require(`@/assets/images/${partner.image}`)" :alt="partner.name">
            </div>
            
            <div class="scroll-row row2">
              <!-- 第二排向左滚动 -->
              <img v-for="partner in partnersRow2" :key="partner.name" :src="require(`@/assets/images/${partner.image}`)" :alt="partner.name">
              <img v-for="partner in partnersRow2" :key="partner.name + '-clone'" :src="require(`@/assets/images/${partner.image}`)" :alt="partner.name">
            </div>
            
            <div class="scroll-row row3">
              <!-- 第三排向右滚动 -->
              <img v-for="partner in partnersRow3" :key="partner.name" :src="require(`@/assets/images/${partner.image}`)" :alt="partner.name">
              <img v-for="partner in partnersRow3" :key="partner.name + '-clone'" :src="require(`@/assets/images/${partner.image}`)" :alt="partner.name">
            </div>
          </div>
        </div>
      </section>

      <!-- 地图区域 -->
      <section class="map-section">
        <div class="map-container">
          <iframe src="https://map.baidu.com/search/%E5%B1%B1%E4%B8%9C%E7%9C%81%E6%9E%A3%E5%B7%9E%E5%B8%82%E6%BB%95%E5%B7%9E%E5%B8%82%E4%BA%BA%E6%89%8D%E5%A4%A7%E5%8E%A6/@13467166.3205,4210279.645,12z?querytype=s&wd=%E5%B1%B1%E4%B8%9C%E7%9C%81%E6%9E%A3%E5%B7%9E%E5%B8%82%E6%BB%95%E5%B7%9E%E5%B8%82%E4%BA%BA%E6%89%8D%E5%A4%A7%E5%8E%A6&c=243&provider=pc-aladin&sug_forward=&sug_index=&src=0&pn=0&device_ratio=2&da_src=shareurl" frameborder="0"></iframe>
        </div>
      </section>
    </main>
    
    <Footer />
    <SideService />
  </div>
</template>

<script>
import Header from '@/components/Header.vue';
import Footer from '@/components/Footer.vue';
import SideService from '@/components/SideService.vue';
export default {
  name: 'About',
  components: {
    Header,
    Footer,
    SideService
  },
  data() {
    return {
      activeTabIndex: 0,
      currentSlide: 0,
      stats: [
        { value: 2, label: '大公司基本' },
        { value: 1000, label: '+企业客户' },
        { value: 98, label: '%客户满意度' },
        { value: 5, label: '+技术专利' }
      ],
      partnersRow1: [
        { name: '江苏星火集团', image: 'jsxhjt.png' },
        { name: '奥克斯', image: 'auxs.png' },
        { name: '腾达科技', image: 'tdkj.png' },
        { name: '贝发集团', image: 'beifa.png' },
        { name: '法尔胜泓异集团', image: 'aeshsjt.png' },
        { name: '丰州科技', image: 'fzkj.png' },
        { name: '海天集团', image: 'haitian.png' },
        { name: '海燕玻璃', image: 'haiyan.png' }
      ],
      partnersRow2: [
        { name: '华为', image: 'huawei.png' },
        { name: '华飞科技', image: 'huafei.png' },
        { name: '金桥焊材', image: 'jqhc.png' },
        { name: '聚思自动化', image: 'jusi.png' },
        { name: '科瑞五金', image: 'krwj.png' },
        { name: '腾龙精细集团', image: 'tenglong.png' },
        { name: '宁波科源石化公司', image: 'keyuan.png' },
        { name: '前程石化', image: 'qiancheng.png' }
      ],
      partnersRow3: [
        { name: '山东威达集团', image: 'weida.png' },
        { name: '辛化集团', image: 'xinhua.png' },
        { name: '雪龍集团', image: 'xuelong.png' },
        { name: '亚太新材料', image: 'yatai.png' },
        { name: '舟山正源', image: 'zhengyuan.png' },
        { name: '贝因美', image: 'beiyinmei.png' },
        { name: '国家电网', image: 'gjdw.png' },
        { name: '有色金属研究院', image: 'ysjsyjy.png' }
      ],
      tabs: [
        {
          id: 'patent',
          name: '专利证书',
          certificates: [
            { image: 'zndxsss.jpg', title: 'RFID智能读写装置专利', icon: 'fas fa-certificate' },
            { image: 'azdzbq.jpg', title: '便于安装电子标签专利', icon: 'fas fa-certificate' },
            { image: 'zndxsb.jpg', title: 'RFID控制电路专利', icon: 'fas fa-certificate' },
            { image: 'syxxzl.jpg', title: '实用新型专利证书', icon: 'fas fa-certificate' },
            { image: 'wgsj.jpg', title: '外观设计专利证书', icon: 'fas fa-certificate' }
          ]
        },
        {
          id: 'software',
          name: '软著证书',
          certificates: [
            { image: 'rzzs1.jpg', title: '腾智企业互联平台开发平台', icon: 'fas fa-code' },
            { image: 'rzzs2.jpg', title: '腾智小工单云MES系统V1.0', icon: 'fas fa-code' },
            { image: 'rzzs3.jpg', title: '微丝自动包装机及控制系统V1', icon: 'fas fa-code' },
            { image: 'rzzs4.jpg', title: '微丝自动包装机及控制系统V2', icon: 'fas fa-code' },
            { image: 'rzzs5.jpg', title: '线材行业数字车间数采平台V1.0', icon: 'fas fa-code' },
            { image: 'rzzs6.jpg', title: '腾智贸易通系统软件V1.0', icon: 'fas fa-code' },
            { image: 'rzzs7.jpg', title: '腾智企业办公管理系统软件V1.0', icon: 'fas fa-code' },
            { image: 'rzzs8.jpg', title: '腾智企业管理系统软件V1.0', icon: 'fas fa-code' },
            { image: 'rzzs9.jpg', title: '腾智生产管理系统软件V1.0', icon: 'fas fa-code' },
            { image: 'rzzs10.jpg', title: '腾智数字看板管理系统软件V1.0', icon: 'fas fa-code' },
            { image: 'rzzs11.jpg', title: '腾智数字展厅系统软件V1.0', icon: 'fas fa-code' },
            { image: 'rzzs12.jpg', title: '腾智下单商城平台V1.0', icon: 'fas fa-code' },
            { image: 'rzzs13.jpg', title: '腾智项目管理系统软件V1.0', icon: 'fas fa-code' },
            { image: 'rzzs14.jpg', title: '腾智移动办公管理系统软件V1.0', icon: 'fas fa-code' },
            { image: 'rzzs15.jpg', title: '腾智云贸通管理系统V1.0', icon: 'fas fa-code' }
          ]
        },
        {
          id: 'system',
          name: '体系证书',
          certificates: [
            { image: 'iso27001.jpg', title: 'ISO27001信息安全管理体系', icon: 'fas fa-shield-alt' },
            { image: 'iso27001.jpg', title: 'ISO27001信息安全管理体系(英文版)', icon: 'fas fa-shield-alt' },
            { image: 'iso9001.jpg', title: 'ISO9001质量管理体系', icon: 'fas fa-award' },
            { image: 'iso9001en.jpg', title: 'ISO9001质量管理体系(英文版)', icon: 'fas fa-award' }
          ]
        },
        {
          id: 'honor',
          name: '荣誉证书',
          certificates: [
            { image: 'ry1.jpg', title: '宁波市智能制造工程服务公司', icon: 'fas fa-trophy' },
            { image: 'ry2.jpg', title: '宁波市软件行业协会会员单位', icon: 'fas fa-trophy' },
            { image: 'ry3.jpg', title: '中小企业优秀服务单位', icon: 'fas fa-medal' },
            { image: 'ry4.jpg', title: '2019年宁波智能制造优秀服务商', icon: 'fas fa-medal' },
            { image: 'ry5.jpg', title: '宁波未来制造联盟成员', icon: 'fas fa-medal' },
            { image: 'ry6.jpg', title: '软件企业', icon: 'fas fa-medal' },
            { image: 'ry7.jpg', title: '高新技术企业证书', icon: 'fas fa-medal' }
          ]
        }
      ],
    };
  },
  methods: {
    setActiveTab(index) {
      this.activeTabIndex = index;
      this.currentSlide = 0;
      this.$nextTick(() => {
        this.updateSlider();
      });
    },
    prevSlide() {
      if (this.currentSlide > 0) {
        this.currentSlide--;
        this.updateSlider();
      }
    },
    nextSlide() {
      const activeTab = this.tabs[this.activeTabIndex];
      const totalSlides = activeTab.certificates.length;
      const slidesPerPage = this.getSlidesPerPage();
      const maxSlide = Math.max(0, totalSlides - slidesPerPage);
      
      if (this.currentSlide < maxSlide) {
        this.currentSlide++;
        this.updateSlider();
      }
    },
    getSlidesPerPage() {
      const width = window.innerWidth;
      if (width <= 576) return 1;
      if (width <= 768) return 2;
      if (width <= 992) return 3;
      return 4;
    },
    updateSlider() {
      const activePane = document.querySelector('.tab-pane.active');
      if (!activePane) return;
      
      const track = activePane.querySelector('.slider-track');
      if (!track) return;
      
      const slidesPerPage = this.getSlidesPerPage();
      const slideWidth = 100 / slidesPerPage;
      const translateX = -(this.currentSlide * slideWidth);
      track.style.transform = `translateX(${translateX}%)`;
    },
    animateNumbers() {
      const statNumbers = document.querySelectorAll('.stat-number');
      statNumbers.forEach(stat => {
        const target = parseInt(stat.getAttribute('data-target'), 10);
        const duration = 2000;
        const step = target / (duration / 50);
        let current = 0;
        
        const timer = setInterval(() => {
          current += step;
          if (current >= target) {
            current = target;
            clearInterval(timer);
          }
          stat.textContent = Math.round(current);
        }, 50);
      });
    }
  },
  mounted() {
    // 页面加载时滚动到顶部
    window.scrollTo(0, 0);
    
    // 初始化AOS动画库
    this.$nextTick(() => {
      if (typeof AOS !== 'undefined') {
        AOS.init({
          duration: 1000,
          once: true,
          offset: 50,
          easing: 'ease-in-out'
        });
      }
    });
    
    // 数字动画
    this.animateNumbers();
    
    // 初始化滑块
    this.$nextTick(() => {
      this.updateSlider();
    });
    
    // 响应式调整
    window.addEventListener('resize', () => {
      this.updateSlider();
    });
  }
}
</script>

<style scoped>
/* 全局变量 */
:root {
  --primary-color: #009b7b;
  --secondary-color: #007a61;
}

/* 特定于About页面的样式 */
.video-section {
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;
}

.video-container {
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
}

#bgVideo {
  position: absolute;
  top: 50%;
  left: 50%;
  min-width: 100%;
  min-height: 100%;
  width: auto;
  height: auto;
  transform: translateX(-50%) translateY(-50%);
}

.video-overlay {
  position: absolute;
  top: 20%;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.glow-text {
  font-size: 3.5rem;
  color: #fff;
  text-shadow: 0 0 10px rgba(0, 155, 123, 0.8);
  margin-bottom: 1rem;
  animation: glow 2s ease-in-out infinite alternate;
}

@keyframes glow {
  from {
    text-shadow: 0 0 10px rgba(0, 155, 123, 0.8);
  }
  to {
    text-shadow: 0 0 20px rgba(0, 155, 123, 0.8),
               0 0 30px rgba(0, 155, 123, 0.6);
  }
}

.sub-text {
  font-size: 1.5rem;
  color: #fff;
  opacity: 0.9;
}

.about-content {
  padding: 80px 0;
  background: linear-gradient(135deg, #f8faf9 0%, #e5f4f1 100%);
}

.about-grid {
  display: grid;
  grid-template-columns: 60% 40%;
  gap: 50px;
  align-items: flex-start;
}

.about-text {
  padding-right: 30px;
}

.section-title {
  font-size: 2.5rem;
  color: var(--primary-color);
  margin-bottom: 30px;
  text-align: center !important;
  position: relative;
}

.section-title::after {
  content: '';
  display: block;
  width: 60px;
  height: 3px;
  background: var(--primary-color);
  margin: 20px auto 0;
}

.company-intro {
  font-size: 1.1rem;
  line-height: 1.5;
  color: #666;
  margin-bottom: 20px;
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 30px;
}

.stat-item {
  text-align: center;
  padding: 20px;
  background: white;
  border-radius: 10px;
  box-shadow: 0 4px 15px rgba(0, 155, 123, 0.1);
  transition: all 0.3s ease;
}

.stat-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 20px rgba(0, 155, 123, 0.2);
}

.stat-number {
  font-size: 2.5rem;
  font-weight: bold;
  color: var(--primary-color);
  margin-bottom: 10px;
}

.stat-label {
  font-size: 1rem;
  color: #666;
}

/* 荣誉资质区域样式 */
.certificates-section {
  padding: 60px 0;
  background-color: #f8f9fa;
}

/* 滑动门导航样式 */
.tab-nav {
  margin-bottom: 30px;
  text-align: center;
}

.tab-nav ul {
  display: inline-flex;
  list-style: none;
  border-bottom: 2px solid #ddd;
  padding: 0;
  margin: 0;
}

.tab-nav li {
  padding: 1rem 2rem;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.3s;
  border-bottom: 3px solid transparent;
  position: relative;
}

.tab-nav li:hover {
  color: var(--primary-color);
}

.tab-nav li.active {
  border-bottom: 3px solid var(--primary-color);
  color: var(--primary-color);
}

.tab-content {
  padding: 2rem 0;
}

.tab-pane {
  display: none;
}

.tab-pane.active {
  display: block;
}

.certificate-slider {
  position: relative;
}

.slider-container {
  overflow: hidden;
  padding: 1rem 0;
}

.slider-track {
  display: flex;
  transition: transform 0.5s ease;
}

.slide {
  flex: 0 0 25%;
  box-sizing: border-box;
  padding: 0 10px;
}

.slide img {
  width: 100%;
  height: auto;
  object-fit: cover;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: transform 0.3s;
}

.slide img:hover {
  transform: scale(1.05);
}

.slide-title {
  padding: 10px;
  text-align: center;
  background: transparent;
  font-size: 0.9rem;
  color: #333;
  margin-top: 10px;
}

.slide-title i {
  margin-right: 5px;
  color: var(--primary-color);
}

.slider-nav {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: var(--primary-color);
  color: white;
  border: none;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
  cursor: pointer;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s;
}

.slider-nav:hover {
  background: var(--secondary-color);
  transform: translateY(-50%) scale(1.1);
}

.slider-nav:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.slider-nav.prev {
  left: -20px;
}

.slider-nav.next {
  right: -20px;
}

.culture-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
  margin-top: 2rem;
}

.culture-item {
  text-align: center;
  padding: 2rem;
  background: #f8f9fa;
  border-radius: 8px;
  transition: all 0.3s;
}

.culture-item:hover {
  transform: translateY(-10px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
}

.culture-icon {
  font-size: 3rem;
  color: #3498db;
  margin-bottom: 1rem;
}

.history-timeline {
  position: relative;
  margin: 2rem 0;
  padding: 2rem 0;
}

.history-timeline::before {
  content: "";
  position: absolute;
  top: 0;
  left: 50%;
  width: 4px;
  height: 100%;
  background: #3498db;
  transform: translateX(-50%);
}

.timeline-item {
  position: relative;
  margin-bottom: 2rem;
  width: 50%;
}

.timeline-item.right {
  margin-left: 50%;
}

.timeline-marker {
  position: absolute;
  top: 0;
  width: 20px;
  height: 20px;
  background: #3498db;
  border-radius: 50%;
  left: -10px;
}

.timeline-item.right .timeline-marker {
  left: -10px;
}

.timeline-content {
  padding: 1.5rem;
  background: #f8f9fa;
  border-radius: 8px;
  margin-left: 20px;
  margin-right: 20px;
  position: relative;
}

.timeline-item.right .timeline-content {
  margin-left: 20px;
}

.year {
  position: absolute;
  top: -40px;
  left: 0;
  font-size: 1.2rem;
  font-weight: bold;
  color: #3498db;
}

.clients-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 2rem;
  margin-top: 2rem;
}

.client-item {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.5rem;
  background: #f8f9fa;
  border-radius: 8px;
  transition: all 0.3s;
}

.client-item:hover {
  transform: scale(1.05);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}

.client-item img {
  max-width: 100%;
  max-height: 60px;
  filter: grayscale(100%);
  transition: filter 0.3s;
}

.client-item:hover img {
  filter: grayscale(0%);
}

/* 合作伙伴滚动样式 */
.partners-section {
  padding: 5rem 0;
  background: #f8f9fa;
  overflow: hidden;
}

.partners-scroll {
  display: flex;
  flex-direction: column;
  gap: 30px;
  margin-top: 2rem;
}

.scroll-row {
  display: flex;
  gap: 30px;
  padding: 20px 0;
  width: 200%;
}

.scroll-row img {
  width: 150px;
  height: 80px;
  object-fit: contain;
  transition: filter 0.3s ease;
  filter: grayscale(50%);
}

.scroll-row img:hover {
  filter: grayscale(0%);
}

.row1, .row3 {
  animation: scrollRight 30s linear infinite;
}

.row2 {
  animation: scrollLeft 30s linear infinite;
}

.scroll-row:hover {
  animation-play-state: paused;
}

@keyframes scrollRight {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-50%);
  }
}

@keyframes scrollLeft {
  from {
    transform: translateX(-50%);
  }
  to {
    transform: translateX(0);
  }
}

@keyframes scrollRight {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-50%);
  }
}

@keyframes scrollLeft {
  from {
    transform: translateX(-50%);
  }
  to {
    transform: translateX(0);
  }
}

/* 地图区域样式 */
.map-section {
  height: 400px;
  margin-bottom: 0;
}

.map-container {
  width: 100%;
  height: 100%;
  position: relative;
}

.map-container iframe {
  width: 100%;
  height: 100%;
  border: none;
}

.certifications-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
  margin-top: 2rem;
}

.certification-item {
  text-align: center;
  padding: 1.5rem;
  background: #f8f9fa;
  border-radius: 8px;
  transition: all 0.3s;
}

.certification-item img {
  max-width: 100%;
  height: 200px;
  object-fit: cover;
  border-radius: 4px;
  margin-bottom: 1rem;
}

.certification-name {
  font-weight: 500;
}

@media (max-width: 992px) {
  .about-grid {
    grid-template-columns: 1fr;
  }
  
  .slide {
    flex: 0 0 33.333%;
  }
  
  .stats-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 768px) {
  .glow-text {
    font-size: 2rem;
  }
  
  .sub-text {
    font-size: 1.2rem;
  }
  
  .slide {
    flex: 0 0 50%;
  }
  
  .partner-item {
    width: 150px;
    height: 80px;
  }
}

@media (max-width: 576px) {
  .slide {
    flex: 0 0 100%;
  }
}
</style>